import wrapWithProvider from './wrap-with-providers';
import CustomLayout from './wrap-page-elements';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = CustomLayout;
